import { render, staticRenderFns } from "./CotTracciamentoChiamateEditComponent.vue?vue&type=template&id=20fca51f"
import script from "./CotTracciamentoChiamateEditComponent.vue?vue&type=script&lang=js"
export * from "./CotTracciamentoChiamateEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports